const __WEBPACK_NAMESPACE_OBJECT__ = require("@datacamp/base-plugin");